// Base imports
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import template from './Edit.vue';

@Component({
	mixins: [template]
})
export default class CustomerEdit extends Vue {}
